/** Subtiele eenmalige pulse op het streak-🔥-icoon (onboarding streak 2). */
export const STREAK_TWO_PULSE_ANIMATION = 'streakTwoPulse 0.8s ease-in-out 1';

/** @returns {import('@mui/material').SxProps} */
export function getStreakTwoIconPulseSx() {
  return {
    '@keyframes streakTwoPulse': {
      '0%': { transform: 'scale(1)' },
      '50%': { transform: 'scale(1.18)' },
      '100%': { transform: 'scale(1)' },
    },
    animation: STREAK_TWO_PULSE_ANIMATION,
  };
}
